import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98a19e84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work-processes" }
const _hoisted_2 = { class: "work-processes__container" }
const _hoisted_3 = { class: "work-processes__items work-items" }
const _hoisted_4 = { class: "work-items__top-elements" }
const _hoisted_5 = { class: "work-items__text-block text-block" }
const _hoisted_6 = { class: "text-block__title" }
const _hoisted_7 = { class: "text-block__annotation" }
const _hoisted_8 = { class: "work-items__text-block text-block" }
const _hoisted_9 = { class: "text-block__title" }
const _hoisted_10 = { class: "text-block__annotation" }
const _hoisted_11 = { class: "work-items__text-block text-block" }
const _hoisted_12 = { class: "text-block__title" }
const _hoisted_13 = { class: "text-block__annotation" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "work-items__separator" }, null, -1))
const _hoisted_15 = { class: "work-items__bottom-elements" }
const _hoisted_16 = { class: "work-items__text-block text-block" }
const _hoisted_17 = { class: "text-block__title" }
const _hoisted_18 = { class: "text-block__annotation" }
const _hoisted_19 = { class: "work-items__text-block text-block" }
const _hoisted_20 = { class: "text-block__title" }
const _hoisted_21 = { class: "text-block__annotation" }
const _hoisted_22 = { class: "work-items__text-block text-block" }
const _hoisted_23 = { class: "text-block__title" }
const _hoisted_24 = { class: "text-block__annotation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileRender = _resolveComponent("MobileRender")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MobileRender),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.WORK_PROCESSES.conceptualDesign.title), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.WORK_PROCESSES.conceptualDesign.mainText), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.WORK_PROCESSES.documentation.title), 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.WORK_PROCESSES.documentation.mainText), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.WORK_PROCESSES.implementation.title), 1),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.WORK_PROCESSES.implementation.mainText), 1)
          ])
        ]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.WORK_PROCESSES.discussion.title), 1),
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.WORK_PROCESSES.discussion.mainText), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.WORK_PROCESSES.development.title), 1),
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.WORK_PROCESSES.development.mainText), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.WORK_PROCESSES.presentation.title), 1),
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.WORK_PROCESSES.presentation.mainText), 1)
          ])
        ])
      ])
    ])
  ]))
}